<app-summary-top i18n-name name="User" [model$]="model$" [summaryItems]="summaryTopItems"></app-summary-top>

<app-tab
  [model]="model$ | async"
  [templates]="[
    { header: detailsHeader, template: details },
    { header: rolesHeader, template: roles },
    { header: chartsHeader, template: charts },
    { header: printersHeader, template: printers }
  ]"
>
</app-tab>

<ng-template #details>
  <app-user-details (saved)="getModel()"></app-user-details>
</ng-template>

<ng-template #roles>
  <app-user-roles></app-user-roles>
</ng-template>

<ng-template #charts>
  <app-user-charts></app-user-charts>
</ng-template>

<ng-template #printers>
  <app-user-printers></app-user-printers>
</ng-template>
